module.exports = __webpack_public_path__ + "static/media/2-item-c.8e5df7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/2-item-c.jpg
// module id = 1159
// module chunks = 33